import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const STEPS = [
  { t: "Make it", d: "Up to 2:00 min, landscape or portrait.", c: "bg-sun" },
  { t: "Send it", d: "Free, with a 100-character description and thumbnail.", c: "bg-sky" },
  { t: "Shortlist", d: "3 Finalists are picked for each category.", c: "bg-grape text-white" },
  { t: "Showcase and vote", d: "Finalists appear on this page. People's Choice by public vote, Jury Award by the panel.", c: "bg-pop" },
  { t: "Reveal", d: "Winners announced on 18th December, and AI/non AI status are revealed.", c: "bg-ink text-paper" },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="bg-paper py-20 text-ink sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-20">
        <Reveal className="lg:sticky lg:top-28 lg:self-start">
          <p className="font-body text-base font-semibold text-ink/80">Five steps, no fees</p>
          <h2 className="mt-3 font-head text-5xl leading-none tracking-tight sm:text-6xl lg:text-7xl">How it works</h2>
          <p className="mt-6 max-w-sm font-body text-lg leading-relaxed text-ink/85">From first frame to the big reveal. Here is the whole journey.</p>
        </Reveal>
        <ol className="flex flex-col">
          {STEPS.map((s, i) => (
            <Reveal as="li" key={s.t} delay={i * 0.05} className="group border-t-2 border-ink/15 py-7 last:border-b-2 sm:py-9" >
              <div data-testid={`how-it-works-step-${i + 1}`} className="flex items-start gap-5 sm:gap-8">
                <motion.span whileHover={{ rotate: -12, scale: 1.08 }} className={`grid h-14 w-14 shrink-0 place-items-center rounded-full font-head text-2xl sm:h-20 sm:w-20 sm:text-4xl ${s.c}`}>
                  {i + 1}
                </motion.span>
                <div className="pt-1 sm:pt-3">
                  <h3 className="font-head text-3xl leading-tight sm:text-4xl">{s.t}</h3>
                  <p className="mt-2 max-w-xl font-body text-base leading-relaxed text-ink/85 sm:text-lg">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
